import { forwardRef, type PropsWithChildren } from "react";

import clsx from "clsx";

import { Button, type ButtonProps } from "./button";

export interface QuickSelectInfoButtonProps
  extends Omit<ButtonProps, "variant"> {
  selected?: boolean;
}

export const QuickSelectInfoButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<QuickSelectInfoButtonProps>
>(({ selected, className, children, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      variant="quick-select"
      className={clsx(
        "text-v2-secondary hover:text-v2-action",
        {
          "font-semibold border-v2-information bg-v2-highlight-information text-v2-action":
            selected,
          "shadow-[inset_2px_2px_2px] shadow-v2-black/10%": selected,
          "hover:border-v2-highlight hover:bg-v2-highlight-information":
            selected,
        },
        className,
      )}
      {...props}
    >
      {children}
    </Button>
  );
});
